import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ConfirmDialogState {
  kind: 'confirm' | 'alert';
  message: string;
  confirmText?: string;
  /** Красная кнопка подтверждения — для удаления и необратимых действий. */
  danger: boolean;
}

/**
 * Подтверждение и сообщение на странице вместо системных confirm()/alert():
 * встроенные браузеры (WhatsApp, Telegram, Instagram, окно приложения) их блокируют
 * и сразу отвечают «Отмена» — кнопка молча не срабатывала.
 * Окно рисует ConfirmDialogComponent в корне приложения.
 */
@Injectable({ providedIn: 'root' })
export class ConfirmDialogService {
  state: ConfirmDialogState | null = null;
  readonly changed$ = new Subject<void>();

  private resolve?: (value: boolean) => void;

  /** true — нажали подтверждение, false — отмена, крестик, Esc или клик по фону. */
  confirm(message: string, options: { confirmText?: string; danger?: boolean } = {}): Promise<boolean> {
    return this.open({ kind: 'confirm', message, confirmText: options.confirmText, danger: options.danger ?? true });
  }

  /** Сообщение с одной кнопкой «Понятно». */
  alert(message: string): Promise<void> {
    return this.open({ kind: 'alert', message, danger: false }).then(() => undefined);
  }

  close(result: boolean): void {
    const resolve = this.resolve;
    this.resolve = undefined;
    this.state = null;
    this.changed$.next();
    resolve?.(result);
  }

  private open(state: ConfirmDialogState): Promise<boolean> {
    // Предыдущее окно, если вдруг открыто, считаем отменённым
    this.resolve?.(false);
    this.state = state;
    this.changed$.next();
    return new Promise<boolean>(resolve => (this.resolve = resolve));
  }
}
